
export const getters = {
  modules: state => state.rolemodules
}

export default getters


// WEBPACK FOOTER //
// ./src/vuex/modules/rolemodules/getters.js